import { CellProps, SelectPicker, Table } from "rsuite";
import { typeCountryDto } from "../../../utils/typeDefs";

export const EditableSelectPickerCell = ({
  rowData,
  dataKey,
  data,
  onChangeEvent,
  ...props
}: CellProps<any> & {
  data: { value: string; label: string }[];
  onChangeEvent: (rowData: typeCountryDto) => void;
}) => {
  const defaultRegionValue = data
    .map((region: { value: string; label: string }) =>
      rowData.regionId === Number(region.value) ? region.label : null
    )
    .filter((regionName: string | null) => regionName !== null)[0];

  return (
    <Table.Cell {...props}>
      <SelectPicker
        data={data}
        placeholder={
          <span className="default-region text-dark">{defaultRegionValue}</span>
        }
        searchable={false}
        size="xs"
        cleanable={false}
        block
        className="me-2"
        placement="autoVerticalEnd"
        onChange={(value) => {
          onChangeEvent({ ...rowData, [dataKey ?? ""]: value });
        }}
      />
    </Table.Cell>
  );
};
